import { render, staticRenderFns } from "./Lgx173450318703493120.vue?vue&type=template&id=7bfcb3d2&scoped=true&"
import script from "./Lgx173450318703493120.vue?vue&type=script&lang=js&"
export * from "./Lgx173450318703493120.vue?vue&type=script&lang=js&"
import style0 from "./Lgx173450318703493120.vue?vue&type=style&index=0&id=7bfcb3d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfcb3d2",
  null
  
)

export default component.exports